import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axiosClient from "../axios";
import loader from "../assets/images/loader.gif";
import SideBar from "./SideBar";
import moment from "moment";
import Pagination_2 from "./Pagination_2";
import "../assets/css/AdminCommon.css";

const DeviceLoginInfo = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const visitorIdParam = params.get("visitorId");
  const userIdParam = params.get("userId");

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    page: 0,
    limit: 100,
  });
  const [searchValue, setSearchValue] = useState(visitorIdParam || userIdParam || "");
  const [searchInput, setSearchInput] = useState(visitorIdParam || userIdParam || "");
  const [showUniqueOnly, setShowUniqueOnly] = useState(false);
  const [methodFilter, setMethodFilter] = useState("all");

  const getData = (searchvalue, isUnique = false) => {
    const finalSearchValue = searchvalue !== undefined ? searchvalue : searchValue;
    
    setLoading(true);
    
    const endpoint = isUnique ? "/unique/logins" : "/admin/device/login";
    const methodParam = !isUnique ? `&method=${methodFilter}` : "";
    
    axiosClient
      .get(
        `${endpoint}?searchValue=${finalSearchValue}&page=${pagination?.page}&limit=${pagination?.limit}${methodParam}`
      )
      .then((res) => {
        setData(res.data.response);
      })
      .catch((error) => {
        console.log(error);
        alert(error?.response?.data?.message || "Error fetching data");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setSearchValue(searchInput);
    setPagination({ ...pagination, page: 0 });
  };

  const handleToggleUnique = () => {
    setShowUniqueOnly(!showUniqueOnly);
    setPagination({ ...pagination, page: 0 });
  };

  const handleClearSearch = () => {
    setSearchValue("");
    setSearchInput("");
    setPagination({ ...pagination, page: 0 });
  };

  useEffect(() => {
    getData(searchValue, showUniqueOnly);
  }, [pagination.page, pagination.limit, searchValue, showUniqueOnly, methodFilter]);

  return (
    <>
      <SideBar handleSideBar={true} activeTab={"UserLoginInfo"} />
      
      <div className="admin-screen-v4">
        {/* Page Header */}
        <div className="admin-header-v4">
          <div>
            <h2>User Login Information</h2>
            {(visitorIdParam || userIdParam) && searchValue && (
              <p style={{ margin: "8px 0 0 0", fontSize: "14px", color: "var(--text-muted)" }}>
                {visitorIdParam && `Filtered by Visitor ID: ${visitorIdParam}`}
                {userIdParam && `Filtered by User ID: ${userIdParam}`}
              </p>
            )}
          </div>
          <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
            <button
              className={showUniqueOnly ? "btn-primary-v4" : "btn-secondary-v4"}
              onClick={handleToggleUnique}
              style={{
                background: showUniqueOnly 
                  ? "linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%)"
                  : "var(--bg-card)",
                color: showUniqueOnly ? "white" : "var(--secondary-color)",
                border: showUniqueOnly ? "none" : "2px solid var(--secondary-color)",
              }}
            >
              {showUniqueOnly ? "Show All Logins" : "Show Unique Users"}
            </button>
          </div>
        </div>

        {/* Search & Filters */}
        <div className="admin-form-container-v4" style={{ marginBottom: "var(--spacing-xl)" }}>
          <form onSubmit={handleSearchSubmit}>
            <div style={{ display: "flex", gap: "var(--spacing-lg)", alignItems: "flex-end", marginBottom: "var(--spacing-md)" }}>
              <div className="form-group-v4" style={{ flex: 1 }}>
                <label className="form-label-v4">
                  Search by User ID, Visitor ID or Device ID
                </label>
                <input
                  type="text"
                  className="form-input-v4"
                  placeholder="Enter User ID, Visitor ID or Device ID..."
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                />
              </div>

              {!showUniqueOnly && (
                <div className="form-group-v4" style={{ minWidth: "280px" }}>
                  <label className="form-label-v4">Login Method</label>
                  <div className="radio-group-v4">
                    <label className="radio-option-v4 no-padding-v4">
                      <input
                        type="radio"
                        checked={methodFilter === "all"}
                        onChange={() => {
                          setMethodFilter("all");
                          setPagination({ ...pagination, page: 0 });
                        }}
                      />
                      <span>All</span>
                    </label>
                    <label className="radio-option-v4 no-padding-v4">
                      <input
                        type="radio"
                        checked={methodFilter === "phone"}
                        onChange={() => {
                          setMethodFilter("phone");
                          setPagination({ ...pagination, page: 0 });
                        }}
                      />
                      <span>Phone</span>
                    </label>
                    <label className="radio-option-v4 no-padding-v4">
                      <input
                        type="radio"
                        checked={methodFilter === "gmail"}
                        onChange={() => {
                          setMethodFilter("gmail");
                          setPagination({ ...pagination, page: 0 });
                        }}
                      />
                      <span>Gmail</span>
                    </label>
                    <label className="radio-option-v4 no-padding-v4">
                      <input
                        type="radio"
                        checked={methodFilter === "truecaller"}
                        onChange={() => {
                          setMethodFilter("truecaller");
                          setPagination({ ...pagination, page: 0 });
                        }}
                      />
                      <span>Truecaller</span>
                    </label>
                  </div>
                </div>
              )}

              <div style={{ display: "flex", gap: "var(--spacing-md)" }}>
                <button type="submit" className="submit-button-v4">
                  Search
                </button>
                {searchValue && (
                  <button
                    type="button"
                    className="cancel-button-v4"
                    onClick={handleClearSearch}
                  >
                    Clear
                  </button>
                )}
              </div>
            </div>
          </form>
          
          {showUniqueOnly && (
            <div
              style={{
                marginTop: "var(--spacing-md)",
                padding: "var(--spacing-md)",
                background: "var(--bg-input)",
                borderRadius: "var(--radius-md)",
                fontSize: "13px",
                color: "var(--text-secondary)",
                border: "1px solid var(--border-color)",
              }}
            >
              ℹ️ Showing only unique users (one record per user, latest login)
            </div>
          )}
        </div>

        {/* Table */}
        <div className="admin-form-container-v4">
          {loading ? (
            <div className="loader-container-v4">
              <img src={loader} alt="Loading..." className="loader-image-v4" />
            </div>
          ) : (
            <>
              {data?.length > 0 ? (
                <>
                  <div style={{ marginTop: "var(--spacing-xl)" }}>
                    <Pagination_2
                      filterDataInput={pagination}
                      setFilterDataInput={setPagination}
                    />
                  </div>
                  <div className="table-container-v4">
                    <table className="data-table-v4">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Device _id</th>
                          <th>User ID</th>
                          <th>User Name</th>
                          <th>User Email</th>
                          <th>User Phone</th>
                          <th>Visitor ID</th>
                          <th>Request ID</th>
                          <th>Method</th>
                          <th>Login At</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((val, key) => (
                          <tr key={key}>
                            <td>{pagination.limit * pagination.page + (key + 1)}</td>
                            <td className="text-mono-v4">{val.deviceId || "N/A"}</td>
                            <td className="text-mono-v4">{val.userId || "N/A"}</td>
                            <td>{val.name || "N/A"}</td>
                            <td>{val?.emailId || "N/A"}</td>
                            <td>{val?.phoneNumber || "N/A"}</td>
                            <td className="text-mono-v4">{val.visitorId || "N/A"}</td>
                            <td className="text-mono-v4">{val.requestId || "N/A"}</td>
                            <td>
                              <span className="status-badge-v4 status-1">
                                {val.method?.toUpperCase() || "N/A"}
                              </span>
                            </td>
                            <td>
                              {val?.loginAt ? moment
                                .utc(val.loginAt)
                                .local()
                                .format("DD/MM/YY, h:mm a") : "N/A"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              ) : (
                <div className="empty-state-v4">
                  <div className="empty-icon-v4">🔍</div>
                  <h3>No Login Data Found</h3>
                  <p>
                    {showUniqueOnly
                      ? "No unique users found matching your criteria"
                      : "No login records found matching your criteria"}
                  </p>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default DeviceLoginInfo;